import { useContext } from 'react'
import { GlobalContextProps, globalContext } from '@/layout'

export default function useAccess() {
  const { access }: GlobalContextProps = useContext(globalContext)

  return access
}
